export default __webpack_public_path__ + "static/media/img_4.7484dffb.jpg";